import {
  StyledContainer,
  StyledIcon,
  StyledContent,
  Title,
  Description,
  Link,
} from "./styles";

export function HelpItem({
  title,
  description,
  url,
  color = "#0033ff",
  icon: Icon,
}) {
  return (
    <StyledContainer>
      <StyledIcon background={color}>
        <Icon style={{ color }} size={30} />
      </StyledIcon>
      <StyledContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Link href={url} color={color}>
          know more
        </Link>
      </StyledContent>
    </StyledContainer>
  );
}